import { render, staticRenderFns } from "./CategoryRoute.vue?vue&type=template&id=b0810c80&scoped=true&"
import script from "./CategoryRoute.vue?vue&type=script&lang=js&"
export * from "./CategoryRoute.vue?vue&type=script&lang=js&"
import style0 from "./CategoryRoute.vue?vue&type=style&index=0&id=b0810c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0810c80",
  null
  
)

export default component.exports